<template>
  <div>
    <Head title="Transferencias de Productos" />
    
    <!-- Header -->
    <div class="mb-8">
      <h1 class="text-3xl font-bold">Transferencias de Productos</h1>
    </div>

    <!-- Barra de Acciones -->
    <div class="flex items-center justify-between mb-6">
      <Link 
        :href="`/deposits/${depositId}/transfer/create`"
        class="btn-indigo"
      >
        <i class="fa fa-plus mr-2"></i>
        <span>Nueva Transferencia</span>
      </Link>
    </div>

    <!-- Tabla de Transferencias -->
    <div class="bg-white rounded-lg shadow-sm overflow-hidden">
      <div class="overflow-x-auto">
        <table class="w-full">
          <thead class="bg-gray-50">
            <tr>
              <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Depósito Emisor
              </th>
              <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Depósito Receptor
              </th>
              <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Fecha
              </th>
              <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Estado
              </th>
              <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Acciones
              </th>
            </tr>
          </thead>
          <tbody class="bg-white divide-y divide-gray-200">
            <tr 
              v-for="transfer in depositTransfers.data" 
              :key="transfer.id"
              class="hover:bg-gray-50"
            >
              <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                {{ transfer.emitter.name }}
              </td>
              <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                {{ transfer.receiver.name }}
              </td>
              <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                {{ formatDate(transfer.date) }}
              </td>
              <td class="px-6 py-4 whitespace-nowrap">
                <span 
                  class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full"
                  :class="getStateClass(transfer.state)"
                >
                  {{ getStateLabel(transfer.state) }}
                </span>
              </td>
              <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                <Link 
                  :href="`/deposits/${depositId}/transfer/${transfer.id}`"
                  class="text-indigo-600 hover:text-indigo-900"
                >
                  <i class="fa fa-eye"></i>
                  <span class="ml-1">Ver Detalles</span>
                </Link>
              </td>
            </tr>
            <tr v-if="!depositTransfers.data.length">
              <td colspan="5" class="px-6 py-4 text-center text-sm text-gray-500">
                No hay transferencias registradas
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- Paginación -->
    <pagination 
      v-if="depositTransfers.links" 
      :links="depositTransfers.links" 
      class="mt-6"
    />
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import Pagination from '@/Shared/Pagination'
import { formatDate } from '@/utils/format'

export default {
  name: 'TransferIndex',

  components: {
    Head,
    Link,
    Pagination,
  },

  layout: Layout,

  props: {
    depositTransfers: Object,
    depositId: Number,
  },

  methods: {
    formatDate,
    
    getStateClass(state) {
      const classes = {
        'prepared': 'bg-yellow-100 text-yellow-800',
        'in_transit': 'bg-blue-100 text-blue-800',
        'completed': 'bg-green-100 text-green-800',
        'cancelled': 'bg-red-100 text-red-800',
      }
      return classes[state] || 'bg-gray-100 text-gray-800'
    },

    getStateLabel(state) {
      const labels = {
        'prepared': 'Preparada',
        'in_transit': 'En Tránsito',
        'completed': 'Completada',
        'cancelled': 'Cancelada',
      }
      return labels[state] || state
    },
  },
}
</script>
